import { legacy as _legacy } from './legacy.js';
import { itemSelector as _itemSelector } from './items-selection/itemSelector.js';
import type { ExposeFieldsBasedOnToggle } from '@wix/sdk-types';

export const itemSelector = _itemSelector;

export const legacy: ExposeFieldsBasedOnToggle<
  typeof _legacy,
  { getContextIds: 'alpha' }
> = _legacy;

export type { AdminHost } from './types.js';

export type {
  ItemSelection,
  ItemSelectionOptions,
  ItemSelectionResult,
  Item,
} from './items-selection/types.js';
